import {NgModule} from '@angular/core';
import {AppCardSideLineComponent} from './card-side-line.component';
import {CoreModule} from '@core/core.module';

@NgModule({
    declarations: [
        AppCardSideLineComponent,
    ],
    imports: [
        CoreModule,
    ],
    exports: [
        AppCardSideLineComponent,
    ],
})
export class AppCardSideLineModule {
}
